export const scriptExtBaseEndpoint =
  process.env.REACT_APP_SCRIPT_EXT_BASE_ENDPOINT;
export const geoJsonFile = 'qld_lga.geo.json';

// export const hhsDataFilePath = 'data/hhs-data.json';
export const dataFile = 'water_data.json';
// export const dataFilePath = `data/${dataFile}`;

export const env =
  process.env.BRANCH === 'staging' ? 'staging' : process.env.NODE_ENV;

export const scriptInjectedFn = {
  _grant_hydrate: () => {},
  getDataFileEndpoint: () => {},
};



// WEBPACK FOOTER //
// ./src/config/index.js